import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Stack } from "ui";

import { Logo } from "components/partials/logo/logo";
import { ContentWrapper } from "components/partials/layout/layout";
import { Typography } from "ui/typography";

import { useCurrentUser } from "hooks/api/use-current-user";

import { hasPermission } from "utilities/user";
import { Route as AppRoute } from "utilities/app-routes";

import { Permission } from "types/auth";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const currentUser = useCurrentUser();
  const isClientUser = hasPermission(currentUser, Permission.PERM_CLIENT_USER);

  const baseRouteBasedOnPermission = isClientUser ? AppRoute.reviews : AppRoute.clients;

  const redirectToDashboard = () => {
    navigate(baseRouteBasedOnPermission);
  };

  return (
    <ContentWrapper
      data-testid="404-page"
      sx={{
        // Chakra's `primary` token is navy, which the MUI palette exposes as `secondary`.
        backgroundColor: "secondary.main",
        position: "absolute",
        height: "100%",
        width: "100%",
      }}>
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          flex: 1,
        }}>
        <Logo isClientUser={isClientUser} sx={{ pr: 5 }} />{" "}
        <Typography
          variant="inherit"
          component="h1"
          sx={{ color: "grey.50", fontSize: "9rem", fontWeight: 700, lineHeight: 1.25 }}>
          404
        </Typography>
        <Typography variant="h2" sx={{ color: "grey.50", mb: 5 }}>
          You're lost in space!
          <br />
          That page doesn't exist.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Button size="large" onClick={redirectToDashboard}>
            Return to homepage
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              window.location.replace(AppRoute.logout);
            }}>
            Logout
          </Button>
        </Box>
      </Stack>
    </ContentWrapper>
  );
};

export default NotFound;
